import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Observable, defer, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GRECAPTCHA_SITE_KEY } from './grecaptcha.token';

@Injectable()
export class GrecaptchaService {
    private readonly renderer: Renderer2;

    constructor(
        @Inject(GRECAPTCHA_SITE_KEY) private siteKey: string,
        private rendererFactory: RendererFactory2
    ) {
        // Get an instance of Renderer2
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    embeddedScript(): void {
        const script = this.renderer.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.siteKey}`;
        this.renderer.appendChild(document.head, script);
    }

    recaptchaToken(action: string = 'deafult_action'): Observable<string> {
        const grecaptcha = window['grecaptcha'];
        if (!grecaptcha || !grecaptcha?.enterprise) {
            return throwError(() => new Error('ReCaptcha is not defined'));
        }

        return defer(
            async () =>
                await grecaptcha.enterprise.execute(this.siteKey, { action })
        ).pipe(catchError((err) => throwError(() => new Error(err))));
    }
}
